import React, { useEffect, useState } from 'react'
import qrCode from '../../../../assets/images/ai-assistant/ai-wechat-qrcode-v3.png'
import tutorialGroupQrCode from '../../../../assets/images/ai-assistant/ai-tutorial-group-qrcode.png'
import workspaceReport from '../../../../assets/images/ai-assistant/workspace-report-v2.webp'
import xiaoguo from '../../../../assets/images/ai-assistant/xiaoguo.webp'
import AiDownloadMenu from './download-menu'
import AiAssistantStory from './story'
import { AI_DESKTOP_DOWNLOADS } from './constants'
import { getAssistantPromotionImages } from './promotion'
import './ai-assistant.scss'

const AiAssistant = () => {
    const [heroImage, setHeroImage] = useState(workspaceReport)
    const [customerServiceQrCode, setCustomerServiceQrCode] = useState(qrCode)
    const [wecomInviteQrCode, setWecomInviteQrCode] = useState(tutorialGroupQrCode)

    useEffect(() => {
        let active = true
        getAssistantPromotionImages('retail_wecom_invite_qr_code')
            .then(images => {
                if (!active) return
                if (images.heroImage) setHeroImage(images.heroImage)
                if (images.customerServiceQrCode) setCustomerServiceQrCode(images.customerServiceQrCode)
                if (images.wecomInviteQrCode) setWecomInviteQrCode(images.wecomInviteQrCode)
            })
            .catch(() => undefined)

        return () => {
            active = false
        }
    }, [])

    return (
        <main className="ai-assistant-page">
            <div className="ai-assistant-scroll">
                <section className="ai-landing-hero">
                    <div className="ai-landing-shell ai-hero-grid">
                        <div className="ai-hero-copy">
                            <h1>
                                让<em>AI</em>真正
                                <br />
                                在农企落地
                            </h1>
                            <p className="ai-hero-description">
                                写文案、做图片、做报表、拟合同、查行情、算损耗、
                                <br />
                                追欠款、设计营销方案等，小果都可以帮你做！
                            </p>
                            <div className="ai-download-wrap">
                                <AiDownloadMenu downloads={AI_DESKTOP_DOWNLOADS} triggerClassName="ai-download-button">
                                    下载森果云 AI 助手 <span aria-hidden="true">↓</span>
                                </AiDownloadMenu>
                            </div>
                            <div className="ai-qrcode-grid" aria-label="AI 助手咨询与教程入口">
                                <article className="ai-qrcode-item">
                                    <div className="ai-qrcode-image">
                                        <img
                                            src={customerServiceQrCode}
                                            alt="森果云 AI 助手客服二维码"
                                            onError={() => setCustomerServiceQrCode(qrCode)}
                                        />
                                    </div>
                                    <h2>AI 助手客服</h2>
                                    <p>微信扫码添加</p>
                                </article>
                                <article className="ai-qrcode-item">
                                    <div className="ai-qrcode-image">
                                        <img
                                            src={wecomInviteQrCode}
                                            alt="森果云农企 AI 落地实战群二维码"
                                            onError={() => setWecomInviteQrCode(tutorialGroupQrCode)}
                                        />
                                    </div>
                                    <h2>农企 AI 落地实战群</h2>
                                    <p>微信扫码进群</p>
                                </article>
                            </div>
                        </div>

                        <div className="ai-workspace" aria-label="森果云 AI 助手桌面端界面截图">
                            <div className="ai-orbit-label">
                                <i />
                                本月经营一图看清
                            </div>
                            <div className="ai-workspace-window">
                                <img
                                    src={heroImage}
                                    alt="森果云 AI 助手生成本月经营健康报告的桌面界面"
                                    onError={() => setHeroImage(workspaceReport)}
                                />
                            </div>
                            <div className="ai-xiaoguo-card">
                                <img src={xiaoguo} alt="" />
                                <span>
                                    有工作，<strong>找小果</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                </section>

                <AiAssistantStory variant="desktop" />
            </div>
        </main>
    )
}

export default AiAssistant
